import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';

import { PrioritySuppliersRequest } from '@/main/models/request/PrioritySuppliersRequest';
import { PrioritySuppliersResponse } from '@/main/models/response/PrioritySuppliersResponse';

export abstract class IPrioritySupplierApi {
  abstract savePrioritySupplier(
    request: PrioritySuppliersRequest
  ): Promise<AxiosResponse<Result<PrioritySuppliersResponse>>>;

  abstract deletePrioritySupplier(
    request: string[]
  ): Promise<AxiosResponse<Result<any>, any>>;
}
